import React, { createContext, useContext, useReducer } from 'react';

const AudioContext = createContext();

const audioReducer = (state, action) => {
  switch (action.type) {
    case 'SET_AUDIO_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const AudioProvider = ({ children }) => {
  const [audioState, dispatch] = useReducer(audioReducer, {
    src: 'https://radio.rsound.cyou/stream.mp3',
    autoPlayAfterSrcChange: false,
    customAdditionalControls: [],
  });

  return (
    <AudioContext.Provider value={{ audioState, dispatch }}>
      {children}
    </AudioContext.Provider>
  );
};

const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }
  return context;
};

export { AudioProvider, useAudio };
